import React from "react"
import { Box, Typography, TextField, FormHelperText } from "@mui/material"
import ValidationErrorText from "../common/ValidationErrorText"

const SocialMediaLinks = ({
  label,
  value = {
    facebook: '',
    linkedin: '',
    x: '',
    youtube: '',
    instagram: '',
  },
  onChange,
  readOnly = false,
  fieldError,
  fieldType,
  fieldErrors
}) => {
  const handleChange = (platform) => (e) => {
    onChange && onChange({ ...value, [platform]: e.target.value })
  }

  const inputStyle = {
    height: 38,
    fontSize: 13,
    '& input': {
      height: '100%',
      padding: '0 14px',
      fontSize: 13,
    },
  }

  const labelStyle = {
    fontSize: 13,
    fontWeight: 500,
    marginBottom: "4px",
  }

  const items = [
    { label: "Facebook", key: "facebook" },
    { label: "LinkedIn", key: "linkedin" },
    { label: "X", key: "x" },
    { label: "YouTube", key: "youtube" },
    { label: "Instagram", key: "instagram" },
  ]

  return (
    <Box>
      <Typography fontSize="14px" fontWeight="500" mb={1}>
        {label}
      </Typography>
      <Box
        sx={{
          display: 'grid',
          gap: 2,
          gridTemplateColumns: {
            xs: '1fr',
            md: 'repeat(3, 1fr)',
            lg: 'repeat(3, 1fr)',
            xl: 'repeat(5, 1fr)',
          },
        }}
      >
        {items.map(({ label, key }) => (
          <Box key={key}>
            <Typography sx={labelStyle}>{label} Link</Typography>
            <TextField
              fullWidth
              value={value[key] || ''}
              onChange={handleChange(key)}
              placeholder={`Enter ${label} Link`}
              InputProps={{ sx: inputStyle, readOnly }}
              disabled={readOnly}
            />
          <ValidationErrorText error={fieldErrors?.[`${fieldType}.${key}`]}/>
          </Box>
        ))}
      </Box>
    </Box>
  )
}

export default SocialMediaLinks
